export default {
  getCurrency: (state) => state.currency,
};
